export enum UserConstants {
    USER_DELETE = 'USER_DELETE',
    USER_LOGIN = 'USER_LOGIN',
    USER_LOGOUT = 'USER_LOGOUT',
    USER_CHANGE_LANGUAGE = 'USER_CHANGE_LANGUAGE',
    USER_SET_IS_AUTORIZED = 'USER_SET_IS_AUTORIZED',
}
